/* eslint-disable */
/**
 * The path of the `TermsPage` to be consumed by a `<Router />`
 * @export
 */
export const TERMS_CONDITIONS_PAGE_PATH = `/terms-conditions`;

/**
 * Create a `href` that will resolve to `TermsPage`
 * @export
 * @returns {string} The `TERMS_CONDITIONS_PAGE_PATH`
 */
export const createTermsPageLink = () => TERMS_CONDITIONS_PAGE_PATH;

/**
 * Determine if the current page is the `TermsPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `TermsPage`
 */
export const isTermsPage = (match) => match.path === TERMS_CONDITIONS_PAGE_PATH;
